import type { InputHTMLAttributes, TextareaHTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

const baseField =
  'w-full rounded-md bg-zinc-950/60 border border-zinc-800 px-3 py-2 text-sm text-zinc-100 placeholder:text-zinc-600 ' +
  'transition-[border-color,box-shadow,background-color] duration-150 ' +
  'hover:border-zinc-700 ' +
  'focus:outline-none focus:border-cyan-500/60 focus:bg-zinc-950/80 focus:shadow-[0_0_0_3px_rgba(34,211,238,0.15),0_0_18px_-4px_rgba(34,211,238,0.4)]'

export function Input({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return <input className={cn(baseField, className)} {...rest} />
}

export function Textarea({ className, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea className={cn(baseField, 'min-h-24 resize-y leading-relaxed', className)} {...rest} />
  )
}

export function Select({
  className,
  children,
  ...rest
}: InputHTMLAttributes<HTMLSelectElement> & { children: React.ReactNode }) {
  return (
    <select
      className={cn(
        baseField,
        'appearance-none pr-8 bg-no-repeat bg-right cursor-pointer',
        className,
      )}
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2367e8f9' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\")",
        backgroundSize: '14px 14px',
        backgroundPosition: 'right 10px center',
      }}
      {...(rest as React.SelectHTMLAttributes<HTMLSelectElement>)}
    >
      {children}
    </select>
  )
}

export function Label({
  htmlFor,
  children,
  className,
}: {
  htmlFor?: string
  children: React.ReactNode
  className?: string
}) {
  return (
    <label
      htmlFor={htmlFor}
      className={cn(
        'block text-[10.5px] uppercase tracking-[0.1em] text-zinc-500 font-medium mb-1',
        className,
      )}
    >
      {children}
    </label>
  )
}
